import { render, staticRenderFns } from "./v-left-card5.vue?vue&type=template&id=2ecfc5ea&scoped=true"
import script from "./v-left-card5.vue?vue&type=script&lang=js"
export * from "./v-left-card5.vue?vue&type=script&lang=js"
import style0 from "./v-left-card5.vue?vue&type=style&index=0&id=2ecfc5ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecfc5ea",
  null
  
)

export default component.exports